import { defaultLanguageFn } from '@core/services/translation/default-lang';
import { AvailableLanguages } from '@core/components/header/lang-selection/lang-selection.config';

export type LanguageState = {
  lang: AvailableLanguages;
  visibilityLang: boolean;
};

export const languageInitialState: LanguageState = {
  lang: defaultLanguageFn(),
  visibilityLang: true,
};
